import template from "./negative-report-modal.html";
import "./negative-report-modal.less";
import {
	forEach,
	fill,
	find,
	findIndex
} from "lodash";
import moment from "moment";
import { VALIDATION_OPERATORS } from "../../../screens/rule-provider/constants.js";

class NegativeReportModalController {
	constructor($scope, eventBus, $logger, api, loadingService, reportScopeFactory, appState) {
		this.$scope = $scope;
		this.eventBus = eventBus;
		this.$logger = $logger;
		this.api = api;
		this.loadingService = loadingService;
		this.reportScopeFactory = reportScopeFactory;
		this.appState = appState;
	}

	$onInit() {
		this.reportScope = this.reportScopeFactory.create({
			form: this.appState.forms.selected,
			report: undefined
		});

		let i = 0;
		forEach(this.resolve.periods, p => {
			const periodYear = moment(p.Period.EndExclusive)
				.year();

			p.Period.beginDropdownDisplay = `${p.Period.Name} 01, ${periodYear}`;

			const periodEndDay = moment(p.Period.EndExclusive)
				.endOf("month")
				.date();
			p.Period.endDropdownDisplay = `${p.Period.Name} ${periodEndDay}, ${periodYear}`;
			p.Period.sortIndex = i++;
		});

		this.beginPeriod = this.resolve.periods[this.resolve.startPeriodIndex].Period;
		this.endPeriod = this.resolve.periods[this.resolve.startPeriodIndex].Period;
		this.beginPeriods = this.resolve.periods.filter((p, index) => index <= this.resolve.startPeriodIndex);
		this.endPeriods = this.resolve.periods.filter((p, index) => index >= this.resolve.startPeriodIndex);
	}

	handleSave() {
		const updates = this.getFormValues(true);

		if(updates === null) {
			throw new Error("save error");
		}
		else if(updates.length < this.resolve.fields.length) {
			this.showValidationErrors(this.resolve.fields.length - updates.length);
			return Promise.reject("Negative fields were not all filled in.");
		}
		else {
			const customReasonVal = find(updates, u => u.String !== undefined);

			if(!!customReasonVal && (customReasonVal.String === "" || customReasonVal.String === null)) {
				this.showValidationErrors(1);
				return Promise.reject("Custom negative reason selected but not filled out.");
			}

			// do api call here
			const periods = this.resolve.periods
				.filter((p) => {
					return p.Period.sortIndex >= this.beginPeriod.sortIndex && p.Period.sortIndex <= this.endPeriod.sortIndex;
				})
				.map(p => ({ Id: p.Period.Id }));

			const negative = {
				EntityId: this.resolve.entityId,
				FormId: this.resolve.form.Id,
				Periods: periods,
				Fields: updates
			};

			const apiCall = this.api
				.post(`api/forms/${this.resolve.form.Id}/reports/negative`, negative)
				.then(response => {
					return this.modalInstance.close(response);
				});

			return this.loadingService.watch(apiCall);
		}
	}

	onBeginUpdate() {
		const index = findIndex(this.resolve.periods, p => p.Period.Id === this.beginPeriod.Id);
		this.endPeriods = this.resolve.periods.filter((p, i) => i >= index);
	}

	onEndUpdate() {
		const index = findIndex(this.resolve.periods, p => p.Period.Id === this.endPeriod.Id);
		this.beginPeriods = this.resolve.periods.filter((p, i) => i <= index);
	}

	handleCancel() {
		this.modalInstance.dismiss("instance dismiss");
	}

	showValidationErrors(numErrors) {
		const errors = [...VALIDATION_OPERATORS];

		forEach(errors, e => {
			if(e.code === "BLOCKSAVE") {
				e.rules = fill(Array(numErrors),
					{
						validationScope: { "Code": "NEGATIVE" },
						Scope: { "Code": "NEGATIVE" },
						Id: 0,
						Title: "All fields are required"
					}
				);
			}
		});

		this.validations = errors;
	}
}

export default angular
	.module("vesl.components.negative-report-modal", [])
	.component("negativeReportModal", {
		controller: NegativeReportModalController,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
